"use client";

import * as React from "react";
import { ArrowRight, Check, Loader, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function InquiryForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center min-h-[400px] text-center animate-in fade-in duration-700">
        <div className="mb-8 inline-flex items-center justify-center size-16 rounded-md border border-primary shadow-lg shadow-primary/20">
          <Check className="size-8 text-primary" />
        </div>
        <p className="font-default text-3xl md:text-4xl text-foreground mb-6 max-w-md leading-tight">
          Thank you. Your inquiry has been sent to George.
        </p>
        <div className="h-px w-12 bg-primary" />
      </div>;
  }
  return <div className="w-full">
      <Form onSubmit={handleSubmit}>
        <div className="space-y-10">
          <div>
            <p className="font-mono text-xs tracking-widest text-primary mb-4">
              — CONTACT
            </p>
            <h3 className="font-default text-2xl md:text-3xl text-foreground leading-tight">
              Start your consultation.
            </h3>
          </div>

          <FormField control={control} name="full_name" rules={{
          required: "Name is required",
          minLength: {
            value: 2,
            message: "Min 2 characters"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="font-mono text-xs tracking-widest text-muted-foreground">
                  FULL NAME
                </FormLabel>
                <FormControl>
                  <Input {...field} placeholder="Your Name" className="border-0 border-b border-border bg-transparent px-0 text-xl md:text-2xl font-default h-14 rounded-md placeholder:text-muted-foreground/20 focus-visible:ring-0 focus-visible:border-primary" />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="phone_number" rules={{
          required: "Phone is required"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="font-mono text-xs tracking-widest text-muted-foreground">
                  PHONE NUMBER
                </FormLabel>
                <FormControl>
                  <Input {...field} type="tel" placeholder="+357 94 043514" className="border-0 border-b border-border bg-transparent px-0 text-xl md:text-2xl font-default h-14 rounded-md placeholder:text-muted-foreground/20 focus-visible:ring-0 focus-visible:border-primary" />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="message" rules={{
          required: "Message is required",
          minLength: {
            value: 10,
            message: "Please provide more detail"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="font-mono text-xs tracking-widest text-muted-foreground">
                  MESSAGE
                </FormLabel>
                <FormControl>
                  <Textarea {...field} placeholder="Describe your vision, placement, and size..." className="border-0 border-b border-border bg-transparent px-0 text-xl font-default rounded-md placeholder:text-muted-foreground/20 focus-visible:ring-0 focus-visible:border-primary min-h-32 resize-none" />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>

        {submitError && <div className="mt-8 p-4 border border-primary/40 rounded-md">
            <p className="font-mono text-xs text-primary">{submitError}</p>
          </div>}

        <div className="flex items-center justify-end mt-16 pt-8 border-t border-border">
          <Button type="submit" disabled={isSubmitting} className="rounded-md px-8 py-6 font-mono text-xs tracking-widest bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20">
            {isSubmitting ? <>
                <Loader className="size-3 mr-2 animate-spin" />
                SENDING
              </> : <>
                SEND EMAIL INQUIRY
                <ArrowRight className="size-3 ml-2" />
              </>}
          </Button>
        </div>
      </Form>
    </div>;
}
export default function SecureYourSession() {
  return <section data-section-id="3839" id="secure-your-session" className="bg-background text-foreground relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-screen">
        <div className="lg:col-span-5 relative lg:sticky lg:top-0 lg:h-screen overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/40 to-background/90" />
          </div>
        </div>

        <div className="lg:col-span-7 bg-background px-6 py-16 md:px-12 md:py-20 lg:px-24 lg:py-32">
          <div className="max-w-2xl mx-auto">
            <FormProvider formKey="secure_session_form_home" formId="secure_session_form_home" sectionName="secure-your-session" defaultValues={{
            full_name: "",
            phone_number: "",
            message: ""
          }} validationRules={{
            full_name: {
              required: true,
              minLength: 2
            },
            phone_number: {
              required: true,
              pattern: "phone"
            },
            message: {
              required: true,
              minLength: 10
            }
          }} submitText="Send Inquiry" successMessage="Thank you. Your inquiry has been sent to George." errorMessage="We couldn't submit your inquiry. Please try again or call George directly.">
              <InquiryForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}